import React from "react";
import "./SelectionSeparator.css";
const SelectionSeparator = () => {
  return <div className="selection-separator"></div>;
};

export default SelectionSeparator;
